/* eslint-disable no-undef */
<template>
  <el-dialog
    :model-value="visible"
    @update:model-value="$emit('update:visible', $event)"
    title="登录"
    width="300px"
    :close-on-click-modal="false"
    :show-close="false"
    center
  >
    <el-form :model="loginForm" @submit.prevent="handleLogin">
      <el-form-item>
        <el-input v-model="loginForm.username" placeholder="用户名" :prefix-icon="User"></el-input>
      </el-form-item>
      <el-form-item>
         <el-input v-model="loginForm.password" type="password" placeholder="密码" :prefix-icon="Lock" show-password @keyup.enter="handleLogin"></el-input>
      </el-form-item>
      <el-form-item>
         <el-button type="primary" @click="handleLogin" :loading="loginLoading" style="width: 100%;">登录</el-button>
      </el-form-item>
    </el-form>
    <div v-if="loginError" style="color: red; font-size: 12px; text-align: center;">{{ loginError }}</div>
    <template #footer>
        <span style="font-size: 12px; color: #999;">请联系管理员获取账号</span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { User, Lock } from '@element-plus/icons-vue';

defineProps({
  visible: Boolean
});

const emit = defineEmits(['update:visible', 'login-success']);

const loginLoading = ref(false);
const loginError = ref('');
const loginForm = reactive({
  username: '',
  password: ''
});

const handleLogin = async () => {
    if(!loginForm.username || !loginForm.password) {
        loginError.value = "请输入用户名和密码";
        return;
    }

    loginLoading.value = true;
    loginError.value = '';

    try {
        const resp = await axios.post('/api/auth/login', loginForm);
        if (resp.data.code === 1) {
            ElMessage.success('登录成功');
            // Reset form
            loginForm.username = '';
            loginForm.password = '';
            emit('login-success', resp.data.data);
            emit('update:visible', false);
        } else {
            loginError.value = resp.data.msg || '登录失败';
        }
    } catch (err) {
        loginError.value = '登录请求失败';
    } finally {
        loginLoading.value = false;
    }
};
</script>
